<div class="relative flex flex-col md:max-w-240 min-h-full lg:min-h-auto md:min-w-240 max-h-full lg:max-h-screen overflow-hidden">
  <!-- Header -->
  <div
    class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 border-b bg-primary text-on-primary">
    <div class="text-2xl">
      <span *ngIf="clientType != 'seller'">
        {{mode == 'create' ? 'Dodawanie nowego klienta' : 'Edycja danych klienta'}}
      </span>
      <span *ngIf="clientType == 'seller'">Edycja danych sprzedawcy</span>
    </div>

    <button mat-icon-button [matDialogClose]="undefined">
      <mat-icon class="text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>

  </div>

  <div class="flex flex-auto overflow-hidden">
    <div class="flex flex-col flex-auto mb-18 overflow-y-auto p-6">
      <div class="grid grid-cols-6 gap-8 pr-3">
        <div class="col-span-6 sm:col-span-3">
          <div class="grid grid-cols-6 gap-3">
            <div class="col-span-6 ">
              <div class="font-semibold">Podstawowe informacje</div>
            </div>

            <!-- NIP / VAT UE - dynamicznie w zależności od kraju -->
            <div class="col-span-6">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Dane identyfikacyjne</mat-label>
                <mat-select [formControl]="form.controls.identifierType" (selectionChange)="onIdentifierTypeChange($event.value)">
                  <mat-option *ngFor="let opt of identifierTypeOptions" [value]="opt.value">
                    {{ opt.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- NIP - widoczny gdy identifierType = 'nip' -->
            <div class="col-span-6" *ngIf="form.controls.identifierType.value === 'nip'">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>NIP</mat-label>
                <input matInput numericOnly [formControl]="form.controls.nip" [readonly]="clientType === 'seller' && mode === 'update'"
                  placeholder="Wprowadź NIP">
                <mat-hint *ngIf="clientType === 'seller' && mode === 'update'">NIP sprzedawcy nie może być zmieniony</mat-hint>
                <mat-error *ngIf="form.controls['nip'].hasError('required')">Pole jest wymagane</mat-error>
              </mat-form-field>
            </div>

            <!-- VAT-UE - widoczny gdy identifierType = 'vatEu' -->
            <ng-container *ngIf="form.controls.identifierType.value === 'vatEu'">
              <div class="col-span-3">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Kraj UE</mat-label>
                  <mat-select [formControl]="form.controls.countryCode" (selectionChange)="onCountryChange($event.value)">
                    <mat-option *ngFor="let country of euCountries" [value]="country.code">
                      {{ country.name }} ({{ country.code }})
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-span-3">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Numer VAT-UE</mat-label>
                  <span matTextPrefix class="text-gray-500 mr-1">{{ form.controls.countryCode.value }}</span>
                  <input matInput [formControl]="form.controls.vatUE" placeholder="Wprowadź numer VAT-UE">
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Identyfikator podatkowy inny - widoczny gdy identifierType = 'other' -->
            <ng-container *ngIf="form.controls.identifierType.value === 'other'">
              <div class="col-span-3">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Kraj</mat-label>
                  <mat-select [formControl]="form.controls.countryCode" (selectionChange)="onCountryChange($event.value)">
                    <mat-option *ngFor="let country of countries" [value]="country.code">
                      {{ country.name }} ({{ country.code }})
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-span-3">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Identyfikator podatkowy</mat-label>
                  <input matInput [formControl]="form.controls.otherTaxIdentifier" placeholder="Wprowadź identyfikator">
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Identyfikator wewnętrzny - widoczny gdy identifierType = 'idWew' -->
            <div class="col-span-6" *ngIf="form.controls.identifierType.value === 'idWew'">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Identyfikator wewnętrzny</mat-label>
                <input matInput [formControl]="form.controls.idWew" placeholder="NIP-numer (np. 6711852031-16006)">
                <mat-hint>Format: NIP-numer (np. 6711852031-16006)</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-span-6">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-select [formControl]="form.controls.type">
                  <mat-option value="company">Firma (działalność gospodarcza)</mat-option>
                  <mat-option value="person">Osoba fizyczna</mat-option>
                </mat-select>
                <mat-label>Typ klienta</mat-label>
              </mat-form-field>
            </div>

            <div class="col-span-6">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Nazwa firmy</mat-label>
                <input matInput [formControl]="form.controls.name">
                <mat-error *ngIf="form.controls['name'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['name'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Imię</mat-label>
                <input matInput [formControl]="form.controls.firstName">
                <mat-error *ngIf="form.controls['firstName'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['firstName'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Nazwisko</mat-label>
                <input matInput [formControl]="form.controls.lastName">
                <mat-error *ngIf="form.controls['lastName'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['lastName'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 mt-5">
              <div class="font-semibold">Adres</div>
            </div>

            <div class="col-span-6">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Ulica i numer</mat-label>
                <input matInput [formControl]="form.controls.street">
                <mat-hint>Jeżeli adres nie ma ulicy, wprowadź nazwę miejscowości oraz numer budynku</mat-hint>
                <mat-error *ngIf="form.controls['street'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['street'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Kod pocztowy</mat-label>
                <input matInput [formControl]="form.controls.postalCode">
                <mat-error *ngIf="form.controls['postalCode'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['postalCode'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Miejscowość</mat-label>
                <input matInput [formControl]="form.controls.city">
                <mat-error *ngIf="form.controls['city'].hasError('required')">Pole jest wymagane</mat-error>
                <mat-error *ngIf="form.controls['city'].hasError('whitespace')">Pole nie może zawierać samych spacji</mat-error>
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3" *ngIf="form.controls.identifierType.value !== 'vatEu' && form.controls.identifierType.value !== 'other'">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>
                  Kraj
                </mat-label>
                <mat-select [formControl]="form.controls.countryCode" (selectionChange)="onCountryChange($event.value)">
                  <mat-option *ngFor="let country of countries" [value]="country.code">
                    {{ country.name }} ({{ country.code }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <div class="grid grid-cols-6 gap-3">
            <div class="col-span-6 mt-5 md:mt-0">
              <div class="font-semibold">Dodatkowe informacje</div>
            </div>

            <div class="col-span-6 md:col-span-3" *ngIf="form.controls.identifierType.value !== 'vatEu'">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>VAT UE</mat-label>
                <span matTextPrefix class="text-gray-500 mr-1">{{ form.controls.countryCode.value }}</span>
                <input matInput [formControl]="form.controls.vatUE" placeholder="Wprowadź VAT UE">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>PESEL</mat-label>
                <input matInput [formControl]="form.controls.pesel" placeholder="Wprowadź PESEL">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Numer dowodu</mat-label>
                <input matInput [formControl]="form.controls.idNumber" placeholder="Wprowadź numer dowodu">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>REGON</mat-label>
                <input matInput [formControl]="form.controls.regon" placeholder="Wprowadź REGON">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>BDO</mat-label>
                <input matInput [formControl]="form.controls.bdo" placeholder="Wprowadź BDO">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>KRS</mat-label>
                <input matInput [formControl]="form.controls.krs" placeholder="Wprowadź KRS">
              </mat-form-field>
            </div>

            <div class="col-span-6">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Pole opisowe</mat-label>
                <textarea matInput [formControl]="form.controls.description" placeholder="Wprowadź opis" rows="3"></textarea>
              </mat-form-field>
            </div>

            <div class="col-span-6 mt-5">
              <div class="font-semibold">Dane kontaktowe</div>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Numer telefonu</mat-label>
                <input matInput [formControl]="form.controls.phoneNumber" placeholder="Wprowadź numer telefonu">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Fax</mat-label>
                <input matInput [formControl]="form.controls.fax" placeholder="Wprowadź numer fax">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Adres e-mail</mat-label>
                <input matInput [formControl]="form.controls.email" placeholder="Wprowadź adres e-mail">
              </mat-form-field>
            </div>

            <div class="col-span-6 md:col-span-3">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Strona WWW</mat-label>
                <input matInput [formControl]="form.controls.www" placeholder="Wprowadź adres www">
              </mat-form-field>
            </div>

            <!-- Sekcja: Widoczność pól na fakturze -->
            <div class="col-span-6 mt-5">
              <div class="font-semibold mb-1">Widoczność pól na fakturze</div>
              <div class="text-xs text-secondary mb-3">Zaznacz pola, które mają być wyświetlane na fakturze</div>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let field of toggleableFields" 
                  mat-stroked-button
                  class="!text-xs !h-7 !min-w-0 !px-2.5"
                  [class.!bg-primary]="fieldsToShow.has(field.key)"
                  [class.!text-on-primary]="fieldsToShow.has(field.key)"
                  [class.!border-primary]="fieldsToShow.has(field.key)"
                  [class.opacity-50]="isFieldLocked(field.key)"
                  [class.cursor-not-allowed]="isFieldLocked(field.key)"
                  (click)="toggleFieldVisibility(field.key)">
                  <mat-icon
                    class="!w-3.5 !h-3.5 !text-sm icon-size-3.5"
                    style="font-size: 14px; line-height: 14px;"
                    [class.text-white]="fieldsToShow.has(field.key)"
                    [class.opacity-40]="!fieldsToShow.has(field.key) && !isFieldLocked(field.key)"
                    [svgIcon]="isFieldLocked(field.key) ? 'tabler_outline:lock' : (fieldsToShow.has(field.key) ? 'tabler_outline:check' : 'tabler_outline:plus')"></mat-icon>
                  <span class="ml-1">{{ field.label }}</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="absolute inset-x-0 bottom-0 py-4 pr-4 pl-1 sm:pr-8 sm:pl-7 border-t z-10 bg-gray-50 dark:bg-gray-900">
    <div class="flex items-end">
      <div class="ml-auto">
        <button [disabled]="form.invalid || loading == true" mat-flat-button color="primary" (click)="saveChanges()">{{
          mode == 'create' ?
          'Dodaj klienta' : 'Zapisz zmiany'}}</button>
        <button mat-flat-button (click)="close()" class="ml-2">Zamknij</button>
      </div>
    </div>
  </div>
</div>